var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurehighintensityintervaltraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.6467 29.7305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 29.7305,
    opacity: 0,
    width: 17.6467,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66712 5.12109C11.0734 5.12109 12.2101 3.97266 12.2101 2.54297C12.2101 1.13672 11.0734 0 9.66712 0C8.23744 0 7.089 1.13672 7.089 2.54297C7.089 3.97266 8.23744 5.12109 9.66712 5.12109ZM12.4093 11.9648C12.8898 12.4688 13.8156 12.4336 14.2374 11.7656L17.0851 7.19531C17.964 5.78906 15.9015 4.66406 15.0929 5.95312L13.0304 9.28125L11.4132 7.65234C9.85462 6.10547 8.1554 5.78906 5.78822 6.05859L1.61634 6.52734C1.07728 6.58594 0.655405 7.01953 0.596811 7.53516L0.0108733 12.1406C-0.176627 13.6172 2.12025 14.0039 2.31947 12.4219L2.78822 8.74219L4.9679 8.49609C5.27259 8.47266 5.48353 8.67188 5.43665 9.01172L4.88587 13.5234C4.61634 15.6562 5.84681 16.8867 7.95619 16.7344L12.2687 16.4297L10.9796 21.1289C10.546 22.7109 12.8312 23.2617 13.2413 21.7266L14.9406 15.4688C15.1515 14.6719 14.6124 13.9922 13.7218 13.9922L9.26869 13.9922L9.83119 10.1484C9.88978 9.77344 10.2296 9.76172 10.4406 9.99609ZM6.04603 17.625L5.76478 21.7969L3.56165 27.3047C3.17494 28.2891 3.87806 28.9688 4.60462 28.9688C5.06165 28.9688 5.51869 28.7227 5.75306 28.1367L8.00306 22.4883C8.0265 22.4062 8.06165 22.3125 8.07337 22.2305L8.72962 17.8242L8.03822 17.8711C7.29994 17.918 6.62025 17.8242 6.04603 17.625Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurehighintensityintervaltraining);
export default __webpack_public_path__ + "static/media/figure.highintensity.intervaltraining.3ea12ce105b194f64f7c614021e1bd01.svg";
export { ForwardRef as ReactComponent };